import {
    ActionIcon,
    Box,
    Button,
    Group,
    Modal,
    Text,
    Tooltip
} from "@mantine/core";
import React from "react";
import { type IModalExportacionExcelTareasCVProps } from "../interfaces";
import FiltroTareasVista from "./filtroTareasVista";
import Tabla from "../../../globales/componentes/tabla/tabla";
import { IconFileTypeXls, IconFilter, IconFilterFilled, IconRefresh } from "@tabler/icons-react";


const ModalExportacionExcelVista: React.FunctionComponent<IModalExportacionExcelTareasCVProps> = ({
    abrirModalExportacionExcel,
    estadoModal,
    filtro,
    tabla,
    manejarCambioFiltroTarea,
    consultarTareas,
    entidadesRegistro,
    limpiarFiltros,
    manejarHabilitarFiltros,
    habilitarFiltros,
    hayRegistros,
    exportarTareasExcel
}) => {

    return (
        <Modal
            closeOnClickOutside={false}
            opened={estadoModal}
            styles={{
                header: { backgroundColor: '#0074d914' }
            }}
            onClose={() => abrirModalExportacionExcel(false)}
            title={<Text fw={500} fz="lg">
                Exportar Tareas a Excel
            </Text>}
            overlayProps={{
                backgroundOpacity: 0.55,
                blur: 1,
                zIndex: 100000,
            }}
            zIndex={100000}
            centered
            size={"90%"}
            radius="md"
            withCloseButton
        >
            <Box 
                p="md" 
                style={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    height: 'auto',
                    maxHeight: '70vh'
                }}
            >
                <Group mb="md" justify="flex-end">
                    <Group gap={4}>
                        <Tooltip
                            label="Refrescar"
                            withinPortal
                            openDelay={100}
                            zIndex={9999}
                            style={{ fontSize: '10px', padding: '3px 5px' }}
                        >
                            <ActionIcon
                                variant="subtle"
                                color="primary"
                                radius="xl"
                                onClick={consultarTareas}
                            >
                                <IconRefresh size={16} />
                            </ActionIcon>
                        </Tooltip>
                        <Tooltip
                            label="Filtrar"
                            withinPortal
                            openDelay={100}
                            zIndex={9999}
                            style={{ fontSize: '10px', padding: '3px 5px' }}
                        >
                            <ActionIcon
                                variant="subtle"
                                color="primary"
                                radius="xl"
                                onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
                            >
                                {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
                            </ActionIcon>
                        </Tooltip>

                    </Group>

                    <Button
                        color="primary"
                        variant="light"
                        size='xs'
                        leftSection={<IconFileTypeXls color="var(--mantine-color-primary-0)" size={12} />}
                        radius="lg"
                        disabled={!hayRegistros}
                        onClick={exportarTareasExcel}
                    >
                        <Text fw={500} size="xs">Exportar a Excel</Text>
                    </Button>
                </Group>

                {habilitarFiltros && (
                    <FiltroTareasVista
                        filtro={filtro}
                        entidadesRegistro={entidadesRegistro}
                        consultarTareas={consultarTareas}
                        limpiarFiltros={limpiarFiltros}
                        estadoModalExportacionExcel={estadoModal}
                        manejarCambioFiltroTarea={manejarCambioFiltroTarea}
                    />
                )}
                <div 
                    style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        overflow: 'auto'
                    }}
                >
                    <Tabla tabla={tabla} />
                </div>
            </Box>
        </Modal >

    );
};

export default ModalExportacionExcelVista;
